import { trackEvent } from '@xingternal/hops-tracking';

type TrackFieldFocusArgs = {
  fieldName: string;
  isMandatory: boolean;
  isAutofilled: boolean;
};

export const trackFieldFocus = ({ fieldName, isMandatory, isAutofilled }: TrackFieldFocusArgs): void => {
  trackEvent('PropTrackAction', {
    EventFormFieldEntry: 1,
    PropFormField: `jobs_${fieldName}`,
    PropContextDimension1: isMandatory ? 'mandatory' : 'optional',
    PropContextDimension2: isAutofilled ? 'autofill' : 'custom',
  });
};

export const trackFormError = (error: string, origin?: string): void => {
  trackEvent('PropTrackAction', {
    PropFormList: 'jobs_apply_form_error',
    PropTrackActionList: error,
    ...(origin && { PropActionOrigin: `jobs_upload_${origin}` }),
  });
};
